import style from "./style.scss";
import Link from "./index";
import { mergeClasses } from "../helpers";

const brandIcons = {
  Matanich: { src: "/icons/logo-square.svg", color: "full" }, //TODO: Rename
  Amazon: { src: "/icons/brands/amazon.svg", color: "#fea43a" },
  EcoFlow: { src: "/icons/brands/ecoflow.svg", color: "#000" },
  Bluetti: { src: "/icons/brands/bluetti.svg", color: "#f3f5f6" },
  Jackery: { src: "/icons/brands/jackery.svg", color: "full" },
};

/**
 * @typedef {object} AffiliateData
 * @property {string} name
 * @property {number} id
 * @property {string} network
 * @property {boolean} enabled
 */

/**
 * @typedef {object} ButtonIcon
 * @property {string} src
 * @property {string} [color]
 */

/**
 * @typedef {"medium" | "small" | null} ButtonSize
 *
 * @typedef {object} ButtonProps
 * @property {import("preact").JSX.AnchorHTMLAttributes["href"]} [href]
 * @property {string} [affiliate]
 * @property {AffiliateData} [affiliateData]
 * @property {boolean} [external]
 * @property {boolean} [blank]
 * @property {import("preact").JSX.AnchorHTMLAttributes["target"]} [target]
 * @property {string} [rel]
 * @property {boolean} [secondary]
 * @property {ButtonSize} [size]
 * @property {ButtonIcon | "Amazon" | "EcoFlow" | "Bluetti" | "Matanich"} [icon]
 * @property {import("preact").JSX.HTMLAttributes["class"]} [class]
 * @property {import("preact").ComponentChildren} children
 *
 * @param {ButtonProps} props
 */
const Button = ({
  type = null, // submit, reset, button
  href,
  affiliate = null,
  affiliateData = null,
  external = false,
  blank = null,
  target = null,
  rel = null,
  secondary = false,
  transparent = false,
  size = null,
  icon = null,
  class: className = null,
  children,
  ...props
}) => {
  const iconData = typeof icon === "string" ? brandIcons[icon] : icon;
  const isFullIcon = iconData && iconData.color === "full";

  const mergedClass = mergeClasses([
    className,
    style.button,
    secondary && style.secondary,
    transparent && style.transparent,
    size == "medium" ? style.medium : null,
    size == "small" ? style.small : null,
    icon ? style.hasIcon : null,
    isFullIcon ? style.fullIcon : null,
  ]);

  const isButton = type == "button" || type == "submit" || type == "reset";

  return isButton ? (
    <button type={type} class={mergedClass} {...props}>
      {icon ? (
        <span
          class={style.icon}
          style={{
            backgroundImage: `url(${iconData.src})`,
            backgroundColor: !isFullIcon ? iconData.color : null,
          }}
        />
      ) : null}
      <span class={style.text}>{children}</span>
    </button>
  ) : (
    <Link
      href={href}
      affiliate={affiliate}
      affiliateData={affiliateData}
      external={external}
      blank={blank}
      target={target}
      rel={rel}
      class={mergedClass}
      {...props}
    >
      {icon ? (
        <span
          class={style.icon}
          style={{
            backgroundImage: `url(${iconData.src})`,
            backgroundColor: !isFullIcon ? iconData.color : null,
          }}
        />
      ) : null}
      <span class={style.text}>{children}</span>
    </Link>
  );
};

export default Button;
